import { statsKey } from '../keys'
import { toTinyLocation } from '../location'
import { type QueryClient, useQueryClient } from '@tanstack/react-query'
import {
  type DispositionId,
  type LocationId,
  Logger,
  type TinyLocationData,
  type AccountStatusId,
  type ExtendedLocationData,
} from '@terros/common'

const logger = new Logger('contact-api')

type ReplaceLocationActivityProps = {
  locationId: LocationId
  disposition?: DispositionId
  statusId?: AccountStatusId
}

type Props = {
  locationId: LocationId
  newLocation: ExtendedLocationData
}

const replaceLocation = (queryClient: QueryClient, { locationId, newLocation }: Props): void => {
  queryClient.invalidateQueries({ queryKey: statsKey() })
  logger.verbose('getting placeholder for', locationId)
  {
    const allSectorCache = queryClient.getQueriesData<TinyLocationData[]>({
      queryKey: ['locations'],
    })
    allSectorCache.forEach(([key, data]) => {
      if (!data) return
      data.forEach((locationCache) => {
        if (locationCache.locationId === locationId) {
          queryClient.setQueryData<TinyLocationData[]>(key, (previous = []) => {
            return previous.map((prev) => {
              const match = prev.locationId === locationId
              return match ? toTinyLocation(newLocation) : prev
            })
          })
        }
      })
    })
  }
}

export const useReplaceLocation = (): ((props: Props) => void) => {
  const queryClient = useQueryClient()
  return (props: Props) => {
    replaceLocation(queryClient, props)
  }
}
